import { axios } from '@Root/API'

export const getTrashed = id => {
	return axios.get(`student-application/into-trash/${id}`)
}
